
const togglePageLock = shouldLock => {
    const $root = document.getElementsByTagName('html')[0];
    if (shouldLock) {
        $root.classList.add('isLocked');
        document.body.classList.add('isLocked');
    } else {
        $root.classList.remove('isLocked');
        document.body.classList.remove('isLocked');
    }
};

export default togglePageLock;
